import { render, staticRenderFns } from "./article-keyword-structure.vue?vue&type=template&id=f7d16e6e"
import script from "./article-keyword-structure.vue?vue&type=script&lang=js"
export * from "./article-keyword-structure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports